export default __webpack_public_path__ + "static/media/Sign-in-light-personal.78ac0e40.svg";